module.exports = __webpack_public_path__ + "img/logo.0221df29.png";